export default __webpack_public_path__ + "static/media/solid.6b199580.svg";